import { inject, Injectable } from '@angular/core';
import type { Observable } from 'rxjs';

import type { TagType } from '@efficiently/models';

import { type TagInput, type TagResult, TagsRepository, type TagToContentInput } from '@efficiently/client-api-tags';
import { GraphQLClient, GraphqlExecutorService } from '@efficiently/client-core-graphql';

import { ASSIGN_TAG_TO_CONTENT, CREATE_TAGS, FIND_TAGS, GET_TAGS, UNASSIGN_TAG_FROM_CONTENT } from '../queries';

@Injectable()
export class TagsGqlRepository extends TagsRepository {
	private readonly gql = inject(GraphqlExecutorService);

	public override findTags(search: string): Observable<TagResult[]> {
		return this.gql.watchOnce(FIND_TAGS, {
			variables: { search },
			client: GraphQLClient.Core,
			select: data => data.findTags,
		});
	}

	public override getTags(type: TagType, projectId: string | null): Observable<TagResult[]> {
		return this.gql.watchOnce(GET_TAGS, {
			variables: { type, projectId },
			client: GraphQLClient.Core,
			select: data => data.tags,
		});
	}

	public override createTags(tags: TagInput[]): Observable<TagResult[]> {
		return this.gql.mutate(CREATE_TAGS, {
			variables: { tags },
			client: GraphQLClient.Core,
			select: data => data.createTags,
		});
	}

	public override assignTagToContent(tagAssignments: TagToContentInput[]): Observable<TagResult[]> {
		return this.gql.mutate(ASSIGN_TAG_TO_CONTENT, {
			variables: { tagAssignments },
			client: GraphQLClient.Core,
			select: data => data.assignTagToContent,
		});
	}

	public override unassignTagFromContent(tagAssignments: TagToContentInput[]): Observable<TagResult[]> {
		return this.gql.mutate(UNASSIGN_TAG_FROM_CONTENT, {
			variables: { tagAssignments },
			client: GraphQLClient.Core,
			select: data => data.unassignTagFromContent,
		});
	}
}
